import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Typography,
} from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faUser } from "@fortawesome/free-solid-svg-icons";
const { Option } = Select;

const { Title, Text } = Typography;

export const PasswordSettings = () => {
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 24,
        offset: 0,
      },
    },
  };
  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    console.log("Received values of form: ", values);
  };
  const logoAlignmentOption = [
    { label: "Left", value: "left" },
    { label: "Center", value: "center" },
    { label: "Right", value: "right" },
  ];
  const [value1, setValue1] = useState("left");

  return (
    <>
      <Title level={4} className="font-weight-400 mt-2 mb-1">
        Change Your Password
      </Title>

      <Card className="topBox">
        <Form
          {...formItemLayout}
          form={form}
          name="register"
          onFinish={onFinish}
          className="mainCardDetailsForm py-4"
          initialValues={{
            residence: ["zhejiang", "hangzhou", "xihu"],
            prefix: "86",
          }}
          scrollToFirstError
        >
          <Form.Item
            name="oldPassword"
            label="Old Password"
            className="cardTextfieldBox residentBox"
            rules={[{ required: true, message: "Please select Residence!" }]}
          >
            <Input
              suffix={<FontAwesomeIcon icon={faUser} />}
              style={{ width: "100%" }}
              className="cardInputfield"
            />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="newPassword"
            label="Enter New Password"
          >
            <Input style={{ width: "100%" }} className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="confirmNewPassword"
            label="Confirm New password"
          >
            <Input className="cardInputfield" />
          </Form.Item>

          <Form.Item
            {...tailFormItemLayout}
            className="cardTextfieldBox mt-auto"
          >
            <Button type="primary" size="large" danger className="px-5">
              Update Password
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Row gutter={[16, 16]}>
        <Col xs={12}>
          <div className="border-8 bg-text font-14 w-100 p-4 mb-3">
            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Agent Code :</span>
                <span>AED 0.01</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Agent Name :</span>
                <span> deepakparwani</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Travel Agency Name :</span>
                <span>deepak parwani</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>User Name :</span>
                <span>deepak@booktoursindubai.com</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Email Id :</span>
                <span>deepak@booktoursindubai.com</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Mobile Number :</span>
                <span>568003993</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Designation :</span>
                <span>Travel Consultant</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Website :</span>
                <span>www.booktoursindubai.com</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Logo Alignment :</span>
                <span>Left</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Refund Type :</span>
                <span>Credit Limit</span>
              </Flex>
            </Title>
          </div>
        </Col>

        <Col xs={12}>
          <div className="border-8 bg-text font-14 w-100 p-4 mb-3">
            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>STREET ADDRESS :</span>
                <span>panoroma grand bur dubai</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>TOWN / CITY :</span>
                <span>Dubai City</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>ZIP CODE :</span>
                <span>0000</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>COUNTRY :</span>
                <span>United Arab Emirates</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>TELEPHONE Number :</span>
                <span>561919971</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>PREFERRED CURRENCY :</span>
                <span>AED</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>SKYPE ID :</span>
                <span>--</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Whatsapp Number :</span>
                <span>971561919971</span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>TRN Number :</span>
                <span></span>
              </Flex>
            </Title>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default PasswordSettings;
